import React from 'react'

import { useStaticQuery, graphql } from 'gatsby'

import Modal from 'react-bootstrap/Modal'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import Button from 'react-bootstrap/Button'

import Team from '../../images/svg/team.svg'
import HolisticAssessment from '../../images/svg/holistic-assess.svg'
import Roadmap from '../../images/svg/map.svg'
import Collaborative from '../../images/svg/collaborative.svg'
import Review from '../../images/svg/review.svg'
import HappyTeam from '../../images/svg/happy-team.svg'
import HappyCertificate from '../../images/svg/happy-certificate.svg'
import Certified from '../../images/svg/certified.svg'

const MyModal = ({ modalShow, modalKey, onHide, onNextClick }) => {

    const data = useStaticQuery(graphql`
        query{
            allContentfulModal{
                        edges{
                            node{
                                modalNumber
                                title
                                body
                                modalLeftButton
                                modalRightButton
                            }
                        }
                    }
                }    
            `)

    const nodeWeWant = data.allContentfulModal.edges.filter((edge) => {
        return edge.node.modalNumber === modalKey
    })

    const { title, body, modalLeftButton, modalRightButton } = nodeWeWant[0].node

    const svgArray = [ Team, HolisticAssessment, Roadmap, Collaborative, Review, HappyTeam, HappyCertificate, Certified ]

    const ModalImage = svgArray[modalKey-1]
    
    return (

        <>
            <Modal
                show={modalShow}
                onHide={onHide}
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title>{title}</Modal.Title>
                </Modal.Header>
                    
                <Modal.Body>
                    <Row className="row align-items-center">
                        <Col md="8" className="ml-auto">
                            <p>{body}</p>
                        </Col>
                        <Col md="4" className="ml-auto">
                            <ModalImage className="img img-fluid p-4"/>
                        </Col>
                    </Row>
                </Modal.Body>

                <Modal.Footer>
                    <Button 
                        variant="secondary"
                        onClick={onHide}
                    >
                        {modalLeftButton}
                    </Button>
                    <Button 
                        variant="primary"
                        onClick={() => onNextClick(modalKey+1)}
                    >
                        {modalRightButton}
                    </Button>
                </Modal.Footer>

            </Modal>
            
        </>
    )
}

export default MyModal
